import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { AlertLoader } from "syf-component-library/ui/atoms";
import { enrollmentType } from "../../../../../const/enrollmentConsts";
import { useAccountFeatures, usePrivacyPolicyQuery, useStatementsEnrollment, } from "../../../../../const/syfApiQueries";
import { useStatementsContext } from "../../../../../context/statementsContext";
import getPaperFeeApplicable from "../../../../../helpers/getPaperFeeApplicable";
import ToggleShowEnrollmentErrorHook from "../../../../../helpers/toggleShowEnrollmentError";
import useStatementsQuery from "../../../../../hooks/useStatementsQuery";
import NoStatementsSection from "../../../../molecules/NoStatementsSection";
import StatementsTable from "../../../../molecules/StatementsTable";
var StatementsListContent = function () {
    var _a;
    var _b = useStatementsContext(), dispatch = _b.dispatch, accountId = _b.state.accountId;
    var isLoadingPrivacyPolicies = usePrivacyPolicyQuery().isLoading;
    var _c = useAccountFeatures(accountId), accountFeatures = _c.data, isLoadingAccountFeatures = _c.isLoading, isAccountFeaturesError = _c.isError;
    var _d = useStatementsQuery(accountId), statementsList = _d.data, isStatementsLoading = _d.isLoading, isStatementsError = _d.isError, refetch = _d.refetch;
    var enrollmentStatusData = useStatementsEnrollment(accountId).data;
    var shouldShowPaperFee = getPaperFeeApplicable(accountFeatures);
    var enrollmentStatus = (_a = enrollmentStatusData === null || enrollmentStatusData === void 0 ? void 0 : enrollmentStatusData.enrollmentType) !== null && _a !== void 0 ? _a : enrollmentType.PAPER;
    var isNoRecentStatements = enrollmentStatus !== enrollmentType.PAPER;
    var hasChangeInTermsProp = statementsList === null || statementsList === void 0 ? void 0 : statementsList.statements.some(function (statement) { var _a; return ((_a = statement.statementDetails) === null || _a === void 0 ? void 0 : _a.changeInTerms) !== undefined; });
    useEffect(function () {
        if (statementsList && !hasChangeInTermsProp) {
            refetch();
        }
    }, [hasChangeInTermsProp, refetch, statementsList]);
    ToggleShowEnrollmentErrorHook(isLoadingAccountFeatures, shouldShowPaperFee, isAccountFeaturesError, dispatch);
    if (isStatementsLoading ||
        isLoadingPrivacyPolicies ||
        isLoadingAccountFeatures) {
        return _jsx(AlertLoader, {});
    }
    if (isStatementsError || !statementsList) {
        return _jsx(NoStatementsSection, { isStatementError: true });
    }
    if (statementsList.statements.length === 0) {
        return _jsx(NoStatementsSection, { isNoRecentStatements: isNoRecentStatements });
    }
    return _jsx(StatementsTable, { statementsList: statementsList.statements });
};
export default StatementsListContent;
